import { put, takeEvery } from 'redux-saga/effects';

import { logger } from '@/config/logger';
import { hideGroupFromSecrets, showGroupInSecrets } from '@/modules/api/codegen';
import { actions as messagesActions } from '@/modules/messages';
import { actions as modalActions, StaticModal } from '@/modules/modals';

import { changeGroupVisibilityRequest, changeGroupVisibilityRequestFailure, changeGroupVisibilityRequestSuccess } from '../actions';

function* changeGroupVisibilityHandler({ meta, payload }: ReturnType<typeof changeGroupVisibilityRequest>) {
    try {
        if (payload.visible) {
            yield showGroupInSecrets({ groupId: meta.groupId });
        } else {
            yield hideGroupFromSecrets({ groupId: meta.groupId });
        }

        yield put(changeGroupVisibilityRequestSuccess(meta.groupId, payload.visible));

        yield put(modalActions.setModalVisibility(StaticModal.HIDE_GROUP, false));
    } catch (e) {
        logger.error(e);

        yield put(changeGroupVisibilityRequestFailure(meta.groupId, e as Error));

        yield put(
            messagesActions.displayErrorMessage({
                message: { id: 'settings.groupsVisibility.error' },
            }),
        );

        yield put(modalActions.setModalVisibility(StaticModal.HIDE_GROUP, false));
    }
}

export function* changeGroupVisibilitySaga() {
    yield takeEvery(changeGroupVisibilityRequest.toString(), changeGroupVisibilityHandler);
}
